import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { StyledWidgetPickerItem, StyledWidgetPickerItemText, StyledDragIcon } from './styles';

export type WidgetPickerItemProps = {
  isSelected?: boolean;
  isDisabled?: boolean;
  isDragging?: boolean;
  onClick?(): void;
  label: string;
};

export const WidgetPickerItem = ({
  isSelected = false,
  isDisabled = false,
  isDragging = false,
  label,
  onClick,
}: WidgetPickerItemProps) => {
  return (
    <StyledWidgetPickerItem isSelected={isSelected} isDisabled={isDisabled} isDragging={isDragging} onClick={onClick}>
      {isDisabled ? (
        <SWReactIcons iconName="locked" size="sm" iconColor={colorsPalettes.carbon[200]} />
      ) : (
        <StyledDragIcon iconName="drag-indicator" size="sm" />
      )}
      <StyledWidgetPickerItemText>{label}</StyledWidgetPickerItemText>
      {isDisabled ? (
        <SWReactIcons
          iconName={isSelected ? 'checkbox-on' : 'checkbox-off'}
          size="sm"
          iconColor={colorsPalettes.carbon[100]}
        />
      ) : (
        <SWReactIcons
          iconName={isSelected ? 'checkbox-on' : 'checkbox-off'}
          size="sm"
          iconColor={isSelected ? colorsPalettes.blue[400] : colorsPalettes.midnight[100]}
        />
      )}
    </StyledWidgetPickerItem>
  );
};
